import React, { useState } from 'react';
import ModalBody from '../modal/ModalBody';
import Modal from '../modal/Modal';
import ModalHeader from '../modal/ModalHeader';
import ErrorBoundary from '../ErrorBoundary';
import CreateTokenIcon from '../Icons/CreateTokenIcon';
import TokenForm, { TokenStatsWithoutId } from './TokenForm';
import Client from '../../utils/network';

const defaultStats: TokenStatsWithoutId = {
    image: '',
    width: 1,
    height: 1,
    borderColor: '#00000000',
    effects: [],
    stats: {
        name: '',
        description: '',
        abilities: {
            strength: 10,
            dexterity: 10,
            constitution: 10,
            intelligence: 10,
            wisdom: 10,
            charisma: 10,
        },
        actions: [],
        skills: {},
        counters: [],
        savingThrows: {},
    },
    assignedUsers: [],
};


export const CreateTokenModal = ({ loadTokens } : { loadTokens: () => void}) => {
    const [show, setShow] = useState(false);
    const [data, setData] = useState<TokenStatsWithoutId>(defaultStats);
    const toggle = () => {
        if(show) {
            setData(defaultStats);
        }
        setShow(!show);
    };

    const onSubmit = (data: TokenStatsWithoutId) => {
        try {
            Client.request('/api/token', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: data,
                }),
            }).then(() => {
                loadTokens();
                return;
            }).catch(() => {
                return;
            }).finally(() => {
                toggle();
            }).catch(() => {
                // do nothing
            });

        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
        }
    };


    return (
        <>
            <button onClick={toggle}>
                <CreateTokenIcon className='w-12 h-12' />
            </button>
            <Modal show={show} toggle={toggle} center>
                <ModalHeader toggle={toggle}>Create token</ModalHeader>
                <ErrorBoundary>
                    <ModalBody>
                        <TokenForm onSubmit={onSubmit} externalData={data} />
                    </ModalBody>
                </ErrorBoundary>
            </Modal>
        </>
    );
};


